"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateId = void 0;
var _string = require("../utils/type-checks/string");
var _uuid = require("uuid");
/**
 * Generates unique ID attribute values
 *
 * @name generateId
 * @param {String} Prefix to start new ID value with
 * @returns {string} ID values derived from prefix and a UUID value
 */
const generateId = prefix => {
  let id = (0, _uuid.v4)();
  if ((0, _string.isStringOfLength)(prefix)) {
    id = [prefix, id].join("-");
  }
  return id;
};
exports.generateId = generateId;